import { Post } from 'components/Post';

const BlogPost = () => <Post sportCategory="football" />;
export default BlogPost;
